import Autoplay from 'embla-carousel-autoplay';
import ClassNames from 'embla-carousel-class-names';
import useEmblaCarousel from 'embla-carousel-react';
import SectionLayout from 'src/layouts/SectionLayout';
import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
} from '../CommonComps/Carousel/CarouselArrowButton';
import PackageCarousel from '../CommonComps/Carousel/PackageCarousel';

const PackagesSection = () => {
  // integration of embla carousel hooks here
  const [emblaRef, emblaAPI] = useEmblaCarousel(
    { containScroll: false, loop: true },
    [Autoplay(), ClassNames()]
  );

  const { onPrevButtonClick, onNextButtonClick } = usePrevNextButtons(emblaAPI);

  // rendering packages section component here
  return (
    <SectionLayout
      id='packages'
      titleFirstPart='Credit'
      titleSecondPart='Purchase plans'
      additionalClassNames='bg-gradient-to-r from-legal-dark-blue via-legal-dark-gray to-legal-dark-blue'
      isFullWidth
      isBgDark
    >
      <div className='w-[95%] max-w-[1800px] lg:w-[90%] xl:w-4/5 mx-auto flex flex-col 2xl:flex-row items-stretch justify-between gap-10 mt-10'>
        <div className='flex flex-col items-center 2xl:items-start justify-between gap-5 py-5'>
          <h2 className='text-3xl md:text-4xl lg:text-5xl text-center 2xl:text-left font-medium text-legal-bg-brown'>
            Access Expert Legal <br /> Services With <br />{' '}
            <span className='font-bold text-legal-brown italic'>
              Flexible Credit System
            </span>
          </h2>

          <div className='flex items-center gap-3 px-3'>
            <PrevButton onClick={onPrevButtonClick} />
            <NextButton onClick={onNextButtonClick} />
          </div>
        </div>

        <PackageCarousel emblaRef={emblaRef} />
      </div>
    </SectionLayout>
  );
};

export default PackagesSection;
